import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import { createPinia } from "pinia";
import { useUserStore } from "@/stores/user";
import { useAuthStore } from "@/stores/auth";
import { userService } from "@/services/userService";
import { authService } from "@/services/authService";
import router from "./router";
import "./assets/css/styles.css";
import { i18n, setLocale } from "./locales/i18n";
import VueFormGenerator, {
  validators,
  fieldInput,
  fieldSelect,
  fieldSwitch,
  fieldTextArea,
} from "vfg-next";
import "vfg-next/dist/vfg-next.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import fieldTipTap from "@/components/Forms/Fields/fieldTipTap.vue";

// Importar las vistas
//import Home from './views/Home.vue'

const app = createApp(App).use(router);
app.config.globalProperties.$axios = axios;

// Global error handler
// app.config.errorHandler = (err, instance, info) => {
//   console.error("Error global:", err, instance, info);

//   // Convertir el error en un mensaje legible
//   // const errorMessage = err.message || "Ha ocurrido un error inesperado.";
//   const errorMessage = `
//     <p><strong>Mensaje:</strong> ${
//       err.message || "Ha ocurrido un error inesperado."
//     }</p>
//     <p><strong>Componente:</strong> ${
//       instance?.$options?.name || "Desconocido"
//     }</p>
//     <p><strong>Información:</strong> ${info}</p>
//   `;
//   app.config.globalProperties.$swal({
//     title: "Error",
//     html: `<p>${errorMessage}</p>`, // Mostrar el mensaje legible
//     icon: "error",
//   });
// };

// app.use(VueRoute)
app.use(VueFormGenerator, {
  components: {
    validators,
    fieldInput,
    fieldSelect,
    fieldSwitch,
    fieldTextArea,
    fieldTipTap,
  },
});

const pinia = createPinia();
app.use(pinia);
app.use(i18n);
app.use(VueSweetalert2);

// Bootstrap de sesión: hidratar usuario tras refresh
(async () => {
  try {
    // Verifica sesión
    const me = await authService.getCurrentUser();
    if (me) {
      const userStore = useUserStore(pinia);
      const authStore = useAuthStore(pinia);
      authStore.login();
      // Carga perfil completo
      const profileResp = await userService.getProfile();
      const profile = profileResp?.data || profileResp;
      setLocale(profile.locale || me.locale);
      userStore.setUser({
        ...me,
        ...profile,
        // fallback por si backend /me trae otros campos
        email: profile.email || me?.email,
        first_name: profile.first_name || me?.first_name,
        last_name: profile.last_name || me?.last_name,
        platform_roles: me?.platform_roles || [],
        platform_permissions: me?.platform_permissions || [],
        teams: me?.teams || [],
        acct_team_uuid: me?.acct_team_uuid ?? null,
      });
    }
  } catch (e) {
    // sin sesión o error: continuar sin bloquear
  } finally {
    app.mount("#app");
  }
})();
